'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Legal = require('./Legal.css');

var _Legal2 = _interopRequireDefault(_Legal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legal = (_dec = (0, _reactCssModules2.default)(_Legal2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Legal, _Component);

  function Legal() {
    (0, _classCallCheck3.default)(this, Legal);
    return (0, _possibleConstructorReturn3.default)(this, (Legal.__proto__ || (0, _getPrototypeOf2.default)(Legal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Legal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Legal';
      var url = _config2.default.domain + _config2.default.routes.legal;

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(title, '', url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'title' },
            title
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'answer-title' },
            'Contact'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'As You Sow'
            ),
            _react2.default.createElement('br', null),
            'Main Post Office',
            _react2.default.createElement('br', null),
            'PO Box 751',
            _react2.default.createElement('br', null),
            'Berkeley, CA 94701'
          ),
          _react2.default.createElement(
            _components.Link,
            {
              to: _config2.default.links.contact,
              xstrong: true,
              title: 'Contact As You Sow' },
            'Contact form',
            _react2.default.createElement(_components.LinkIcon, null)
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'answer-title' },
            'Terms of use'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'Last Modified:  June 23, 2022'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Acceptance of the Terms of Use'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'These terms of use are entered into by and between You and As You Sow ("Organization," "we," "us," or \u201Cour\u201D). The following terms and conditions, together with any documents they expressly incorporate by reference (collectively, "Terms of Use"), govern your access to and use of our website, www.asyousow.org, including any content, functionality and services offered on or through our website (the "Website").'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Please read the Terms of Use carefully before you start to use the Website. By using the Website or by clicking to accept or agree to the Terms of Use when this option is made available to you, you accept and agree to be bound and abide by these Terms of Use and our Privacy Policy, found at https://www.asyousow.org/legal-disclaimer#privacypolicy, which is incorporated here by reference. If you do not want to agree to these Terms of Use or the Privacy Policy, you must not access or use the Website. '
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'COPPA'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Children\'s Online Privacy Protection Act (COPPA) was passed to give parents increased control over what information is collected from their children online and how such information is used. The law applies to websites and services directed to, and which knowingly collect information from, children under the age of 13. The Website is not directed to children under the age of 13, nor is information knowingly collected from them. For additional information on COPPA protections, link to the Federal Trade Commission\'s website at https://www.ftc.gov/business-guidance/privacy-security/childrens-privacy.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Changes to the Terms of Use'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'We may revise and update these Terms of Use from time to time in our sole discretion. All changes are effective immediately when we post them. However, any changes to the dispute resolution provisions set forth in Governing Law and Jurisdiction provisions will not apply to any disputes for which the parties have actual notice prior to the date the change is posted on the Website.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Your continued use of the Website following the posting of revised Terms of Use means that you accept and agree to the changes. You are expected to check this page frequently so you are aware of any changes, as they are binding on you.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Accessing the Website and Account Security'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'We reserve the right to withdraw or change this Website, and any service or material we provide on the Website, in our sole discretion without notice. We will not be liable if for any reason all or any part of the Website is unavailable at any time or for any period. From time to time, we may restrict access to some parts of the Website, or the entire Website, to users, including registered users.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You are responsible for making all arrangements necessary for you to have access to the Website and ensuring that all persons who access the Website through your internet connection are aware of these Terms of Use and comply with them.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To access the Website or some of the resources it offers, you may be asked to provide certain registration details or other information. It is a condition of your use of the Website that all the information you provide on the Website is correct, current and complete. You agree that all information you provide to register with this Website or otherwise, including but not limited to, through the use of any interactive features on the Website, is governed by our https://www.asyousow.org/legal-disclaimer#privacypolicy, and you consent to all actions we take with respect to your information consistent with our Privacy Policy.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you choose, or are provided with, a user name, password or any other piece of information as part of our security procedures, you must treat such information as confidential, and you must not disclose it to any other person or entity. You also acknowledge that your account is personal to you and agree not to provide any other person with access to this Website or portions of it using your user name, password or other security information. You agree to notify us immediately of any unauthorized access to or use of your user name or password or any other breach of security. You also agree to ensure that you exit from your account at the end of each session. You should use particular caution when accessing your account from a public or shared computer so that others are not able to view or record your password or other personal information.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We have the right to disable any user name, password or other identifier, whether chosen by you or provided by us, at any time in our sole discretion for any or no reason, including if, in our opinion, you have violated any provision of these Terms of Use.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Intellectual Property Rights'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Website and its entire contents, features and functionality (including but not limited to all information, software, text, displays, images, video and audio, and the design, selection and arrangement thereof), are owned by the Organization, its licensors or other providers of such material and are protected by United States and international copyright, trademark, patent, trade secret and other intellectual property or proprietary rights laws.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'These Terms of Use permit you to use the Website for your personal, non-commercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store or transmit any of the material on our Website, except as follows:  (1) your computer may temporarily store copies of such materials in RAM incidental to your accessing and viewing those materials; (2) you may store files that are automatically cached by your Web browser for display enhancement purposes; and (3) you may print or download one copy of a reasonable number of pages of the Website for your own personal, non-commercial use and not for further reproduction, publication or distribution, provided you agree to be bound by our end user license agreement for such applications.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You must not: (1) modify copies of any materials from this site; (2) use any illustrations, photographs, video or audio sequences or any graphics separately from the accompanying text; (3) delete or alter any copyright, trademark or other proprietary rights notices from copies of materials from this site; or (4) access or use for any commercial purposes any part of the Website or any services or materials available through the Website. '
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you print, copy, modify, download or otherwise use or provide any other person with access to any part of the Website in breach of the Terms of Use, your right to use the Website will cease immediately and you must, at our option, return or destroy any copies of the materials you have made. No right, title or interest in or to the Website or any content on the Website is transferred to you, and all rights not expressly granted are reserved by the Organization. Any use of the Website not expressly permitted by these Terms of Use is a breach of these Terms of Use and may violate copyright, trademark and other laws.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Licensing'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you would like to license As You Sow data, please contact As You Know.  It is the exclusive licensee of As You Sow data and has rights to sublicense that data to others.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Trademarks'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'As You Sow\xAE, Proxy Preview\xAE, Clean200\xAE, and Carbon Clean 200\xAE, together with the Organization\u2019s logos, product and service names, designs and slogans are trademarks of the Organization or its affiliates or licensors. You must not use such marks without the prior written permission of the Organization. All other names, logos, product and service names, designs and slogans on this Website are the trademarks of their respective owners.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Prohibited Uses'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'You may use the Website only for lawful purposes and in accordance with these Terms of Use. You agree not to use the Website:  (1) in any way that violates any applicable federal, state, local or international law or regulation (including, without limitation, any laws regarding the export of data or software to and from the US or other countries); (2) to send, knowingly receive, upload, download, use or re-use any material which does not comply with the Content Standards set forth in these Terms of Use; (3) to transmit, or procure the sending of, any advertising or promotional material, including any "junk mail," "chain letter," "spam," or any other similar solicitation; (4) to impersonate or attempt to impersonate the Organization, an Organization employee, another user or any other person or entity (including, without limitation, by using e-mail addresses associated with any of the foregoing); (5) to engage in any other conduct that restricts or inhibits anyone\'s use or enjoyment of the Website, or which, as determined by us, may harm the Organization or users of the Website, or expose them to liability; (6) use the Website in any manner that could disable, overburden, damage, or impair the site or interfere with any other party\'s use of the Website, including their ability to engage in real time activities through the Website; (7) use any robot, spider or other automatic device, process or means to access the Website for any purpose, including monitoring or copying any of the material on the Website; (8) use any manual process to monitor or copy any of the material on the Website, or for any other purpose not expressly authorized in these Terms of Use, without our prior written consent; (9) use any device, software or routine that interferes with the proper working of the Website; (10) introduce any viruses, trojan horses, worms, logic bombs or other material which is malicious or technologically harmful; (11) attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of the Website, the server on which the Website is stored, or any server, computer or database connected to the Website; (12) attack the Website via a denial-of-service attack or a distributed denial-of-service attack; or (13) otherwise attempt to interfere with the proper working of the Website.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Reliance on Information Posted'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'The information presented on or through the Website is made available solely for general information purposes and the implementation of the Organization\u2019s charitable mission. We do not warrant the accuracy, completeness or usefulness of this information. Any reliance you place on such information is strictly at your own risk. We disclaim all liability and responsibility arising from any reliance placed on such materials by you or any other visitor to the Website, or by anyone who may be informed of any of its contents.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This Website may include content provided by third parties, including materials provided by the Organization\u2019s content partners,  and/or reporting services. All statements and/or opinions expressed in these materials, and all articles and responses to questions and other content, other than the content provided by the Organization, are solely the opinions and the responsibility of the person or entity providing those materials. These materials do not necessarily reflect the opinion of the Organization. We are not responsible, or liable to you or any third party, for the content or accuracy of any materials provided by any third parties.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Changes to the Website'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'We may update the content on this Website from time to time, but its content is not necessarily complete or up-to-date. Any of the material on the Website may be out of date at any given time, and we are under no obligation to update such material.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Information About You and Your Visits to the Website'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'All information we collect on this Website is subject to our https://www.asyousow.org/legal-disclaimer#privacypolicy. By using the Website, you consent to all actions taken by us with respect to your information in compliance with the Privacy Policy.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Linking to the Website and Social Media Features'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'You may link to our homepage, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it, but you must not establish a link in such a way as to suggest any form of association, approval or endorsement on our part.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This Website may provide certain social media features that enable you to:  (1) link from your own or certain third-party websites to certain content on this Website; (2) send e-mails or other communications with certain content, or links to certain content, on this Website; and (3) cause limited portions of content on this Website to be displayed or appear to be displayed on your own or certain third-party websites.  You may use these features solely as they are provided by us, solely with respect to the content they are displayed with, and otherwise in accordance with any additional terms and conditions we provide with respect to such features. Subject to the foregoing, you must not:  (1) establish a link from any website that is not owned by you; (2) cause the Website or portions of it to be displayed, or appear to be displayed by, for example, framing, deep linking or in-line linking, on any other site; (3) link to any part of the Website other than the homepage; or (4) otherwise take any action with respect to the materials on this Website that is inconsistent with any other provision of these Terms of Use. The website from which you are linking, or on which you make certain content accessible, must comply in all respects with the Content Standards set out in these Terms of Use.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You agree to cooperate with us in causing any unauthorized framing or linking immediately to cease. We reserve the right to withdraw linking permission without notice. We may disable all or any social media features and any links at any time without notice in our discretion.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Links from the Website'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'If the Website contains links to other sites and resources provided by third parties, these links are provided for your convenience only. This includes links contained in advertisements, including banner advertisements and sponsored links. We have no control over the contents of those sites or resources, and accept no responsibility for them or for any loss or damage that may arise from your use of them. If you decide to access any of the third party websites linked to this Website, you do so entirely at your own risk and subject to the terms and conditions of use for such websites.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Geographic Restrictions'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'The owner of the Website is based in the State of California in the United States. We make no claims that the Website or any of its content is accessible or appropriate outside of the United States. Access to the Website may not be legal by certain persons or in certain countries. If you access the Website from outside the United States, you do so on your own initiative and are responsible for compliance with local laws.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Disclaimer of Warranties'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'You understand that we cannot and do not guarantee or warrant that files available for downloading from the internet or the Website will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to our site for any reconstruction of any lost data. WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE OR TO YOUR DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'YOUR USE OF THE WEBSITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE IS AT YOUR OWN RISK. THE WEBSITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. NEITHER THE COMPANY NOR ANY PERSON ASSOCIATED WITH THE COMPANY MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE WEBSITE. WITHOUT LIMITING THE FOREGOING, NEITHER THE COMPANY NOR ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE WEBSITE, ITS CONTENT OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL BE ACCURATE, RELIABLE, ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS. '
            ),
            _react2.default.createElement(
              'p',
              null,
              'THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR PARTICULAR PURPOSE.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Limitation on Liability'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL THE COMPANY, ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH OTHER WEBSITES OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE OR SUCH OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Indemnification'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'You agree to defend, indemnify and hold harmless the Organization, its affiliates, licensors and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses or fees (including reasonable attorneys\' fees) arising out of or relating to your violation of these Terms of Use or your use of the Website, including, but not limited to, your User Contributions, any use of the Website\'s content, services and products other than as expressly authorized in these Terms of Use, or your use of any information obtained from the Website.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Governing Law and Jurisdiction'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'All matters relating to the Website and these Terms of Use, and any dispute or claim arising therefrom or related thereto (in each case, including non-contractual disputes or claims), shall be governed by and construed in accordance with the internal laws of the State of California without giving effect to any choice or conflict of law provision or rule (whether of the State of California or any other jurisdiction).'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Any legal suit, action or proceeding arising out of, or related to, these Terms of Use or the Website shall be instituted exclusively in the federal courts of the United States or the courts of the State of California, in each case located in the City of Oakland and County of Alameda,. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Waiver and Severability'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'No waiver of by the Organization of any term or condition set forth in these Terms of Use shall be deemed a further or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure of the Organization to assert a right or provision under these Terms of Use shall not constitute a waiver of such right or provision.  If any provision of these Terms of Use is held by a court or other tribunal of competent jurisdiction to be invalid, illegal or unenforceable for any reason, such provision shall be eliminated or limited to the minimum extent such that the remaining provisions of the Terms of Use will continue in full force and effect.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Entire Agreement'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Terms of Use and our Privacy Policy constitute the sole and entire agreement between you and As You Sow with respect to the Website and supersede all prior and contemporaneous understandings, agreements, representations and warranties, both written and oral, with respect to the Website.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Your Comments and Concerns'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'This website is operated by As You Sow, Main Post Office, PO Box 751, Berkeley, CA 94701.  All notices of copyright infringement claims should be sent to the Organization by e-mail at info@asyousow.org.  All other feedback, comments, requests for technical support and other communications relating to the Website should be directed to: info@asyousow.org, Main Post Office, PO Box 751, Berkeley, CA 94701.'
            )
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'answer-title' },
            'Disclaimer'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                '** As You Sow is not an investment adviser as that term is defined under federal and state (California) laws and regulations.  As You Sow is a tax-exempt, nonprofit organization dedicated to educating and empowering shareholders to change corporations for the good through the collection, analysis and dissemination of relevant information to the public, free of charge.  As You Sow does not provide financial planning, legal or tax advice. Nothing on this website shall constitute or be construed as an offering of financial instruments, or as investment advice or investment recommendations.**'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'The aggregated information comprising ',
              _config2.default.app.title,
              ' represents a snapshot in time of publicly available information regarding mutual fund investments in public companies, provided monthly by Morningstar.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The information provided in ',
              _config2.default.app.title,
              ' is provided \u201CAS IS\u201D without warranty of any kind. As You Sow makes no representations and provides no warranties regarding any information or opinions provided herein, including, but not limited to, the advisability of investing in any particular company or investment fund or other vehicle. While we have obtained information believed to be objectively reliable, neither As You Sow nor any of its employees, officers, directors, trustees, or agents, shall be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any information contained herein, including, but not limited to, lost profits or punitive or consequential damages. Past performance is not indicative of future returns.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As You Sow does not provide investment, financial planning, legal or tax advice. We are neither licensed nor qualified to provide any such advice. The content of our programming, publications and presentations is provided free of charge to the public for informational and educational purposes only, and should not be considered as information sufficient upon which to base any decisions on investing, purchases, sales, trades, or any other investment transactions. We do not express an opinion on the future or expected value of any security or other interest and do not explicitly or implicitly recommend or suggest an investment strategy of any kind.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Our events, websites, and promotional materials may contain external links to other resources, and may contain comments or statements by individuals who do not represent As You Sow. As You Sow has no control over, and assumes no responsibility for the content, privacy policies, or practices of any third party websites or services that you may access as a result of our programming. As You Sow shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such websites or services.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Copyright ',
              _react2.default.createElement(
                'i',
                null,
                'As You Sow'
              ),
              ' \xA9 ',
              new Date().getFullYear(),
              '. All rights reserved.'
            )
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'answer-title' },
            'Privacy policy'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'answer-info' },
            _react2.default.createElement(
              'p',
              null,
              'This privacy policy has been updated as of February 5, 2019. It applies solely to information collected by fossilfreefunds.org, deforestationfreefunds.org, tobaccofreefunds.org, weaponfreefunds.org, and genderequalityfunds.org.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As You Sow is committed to user privacy. Our Privacy Policy is intended to ensure that your personal information is handled in a safe and responsible manner. This Policy addresses:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'what personally identifiable information is collected from you through the fossilfreefunds.org, deforestationfreefunds.org, tobaccofreefunds.org, weaponfreefunds.org, and genderequalityfunds.org websites, how this information is used and with whom it may be shared;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'what choices are available to you regarding the use of your data;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'the security procedures in place to protect against the misuse of your information; and'
              ),
              _react2.default.createElement(
                'li',
                null,
                'how you can correct any inaccuracies in the information.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Information collection, use and sharing'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'As You Sow is the sole owner of the information collected on the fossilfreefunds.org, deforestationfreefunds.org, tobaccofreefunds.org, weaponfreefunds.org, and genderequalityfunds.org websites. We only have access to/collect information that you voluntarily give us via email or other direct contact from you. We will not sell or rent this information to anyone.  We do not use third-party advertisement networks, or other networks that follow you across the web. As you browse our websites, we use analytics services to ensure you\'re finding the content you\'re looking for, but we do not correlate this information to individual users.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'When you share your name, address or e-mail address with us, by joining our mailing list or making a donation to As You Sow, we may use this information to send you information about As You Sow\'s activities, webinar invitations, and other information. You may customize your e-mail preferences to receive only certain types of e-mail.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Your access to and control over information'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'We respect e-mail opt-outs. You may opt out of any future contacts from us at any time. If you unsubscribe from our e-mail service, we cannot re-enable your account. If you would like to re-join our e-mail list, please use our ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.contact, xstrong: true, title: 'Contact As You Sow' },
                'contact form.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'You can do the following at any time by contacting us via the email address or phone number provided above and on the As You Sow website (asyousow.org):'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'see what data we have about you, if any;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'change/correct any data we have about you;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'have us delete any data we have about you;'
              ),
              _react2.default.createElement(
                'li',
                null,
                'express any concern you have about our use of your data.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'As You Sow uses Google Analytics to determine efficacy of our content placement. We do not use the software to track individual users.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Security'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'We take precautions to protect your information.  When you submit sensitive information via the fossilfreefunds.org, deforestationfreefunds.org, tobaccofreefunds.org, weaponfreefunds.org, and genderequalityfunds.org websites, your information is protected both online and offline.  We encrypt your connection to our websites and to our donation processor over HTTPS.  You can verify this by looking for a lock icon in the address bar and looking for \u201Chttps\u201D at the beginning of the address of the web page.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'While we use encryption to protect sensitive information transmitted online, we also protect your information offline. Only employees who need the information to perform a specific job (for example, billing or customer service) are granted access to personally identifiable information. The computers/servers in which we store personally identifiable information are kept in a secure environment.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We process our e-mails through ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.pardot.com/', xstrong: true },
                'Pardot'
              ),
              ', which we share with our ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.salesforce.com/', xstrong: true },
                'Salesforce'
              ),
              ' database. For information on Salesforce and Pardot, see Salesforce\'s ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.pardot.com/legal/permission-based-marketing-policy/', xstrong: true, title: 'Pardot privacy policy' },
                'e-mail privacy policy'
              ),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Donations to As You Sow are handled by ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://clickandpledge.com/', xstrong: true },
                'Click and Pledge'
              ),
              ' on their servers. All donation information is secured over SSL (secure socket layer). For specific information on Click and Pledge, see their ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://clickandpledge.com/privacy/', xstrong: true, title: 'Click & Pledge privacy policy' },
                'privacy policy'
              ),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Social networks'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'As You Sow regularly shares content through Facebook, Twitter, Instagram, and LinkedIn. We do not correlate website data and social network data, and do not host social network widgets on our site. As You Sow is not responsible for the content or privacy practices of such other sites. If you choose to interact with As You Sow over these platforms, you may share personal data with these services and with us. Please see the privacy policies for these companies if you would like more information.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Surveys'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'On occasion, we may ask our site visitors to participate in voluntary surveys about our work. Survey information will be used for purposes of research in our issues areas, or to improve our services. If you participate in our surveys, you agree to share non-personally identifying information with us through our survey utility, SurveyGizmo. SurveyGizmo\u2019s privacy policy is ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.surveygizmo.com/privacy/', xstrong: true, title: 'SurveyGizmo privacy policy' },
                'detailed here'
              ),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'If you feel that we are not abiding by this Privacy Policy, please contact us using our ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.contact, xstrong: true, title: 'Contact As You Sow' },
                  'contact form'
                ),
                '.'
              )
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(_components.AboutBanner, null)
        )
      );
    }
  }]);
  return Legal;
}(_react.Component)) || _class);
exports.default = Legal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Legal/Legal.js
// module id = 1338
// module chunks = 0